import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';

@Component({
  selector: 'app-ssct',
  standalone: false,
  templateUrl: './ssct.component.html',
  styleUrl: './ssct.component.scss'
})
export class SsctComponent implements OnInit, OnDestroy, AfterViewInit {
  RFPForm: FormGroup;
  uploadedFiles: File[] = [];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Input() schemeType: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  isEditorDisabled: boolean = false;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  init: EditorComponent['init'] = init;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  file: File;
  @Input() id: any;
  private subscriptions = new Subscription();
  userID: any;
  allDmsFiles: any[]=[];
 

  constructor(private fb: FormBuilder, private config: PrimeNGConfig, 
    private messageService: MessageService, private api: ApiService, 
    private uploadService: UploadService, private route: ActivatedRoute) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
   }

  ngOnInit(): void {
    this.RFPForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.getRfpDetails()
  }
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
    expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if ( this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.RFPForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.RFPForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }
  rfpdata: any;
  getRfpDetails() {
    const sub = this.api.getAPI(`/make1/ssct/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
      this.rfpdata = res[0];
      this.uploadedUrl = res[0]?.file || null;
   
      
      this.RFPForm.patchValue({
        comment: this.rfpdata?.justification
      });
    });
    this.subscriptions.add(sub);
  }



  onSubmit(): void {
    // if (this.commentForm.valid) {
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('justification', this.RFPForm.get('comment').value);
   

    if (this.rfpdata) {
      const sub = this.api.putAPI(`/make1/ssct/${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedUrl = null
         this.uploadedFileName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'SSCT updated successfully' });
      });
      this.subscriptions.add(sub);

    } else {
      const sub = this.api.postAPI('/make1/ssct/', formData).subscribe((res: any) => {
        this.getRfpDetails();
         this.uploadedUrl = null;
        this.uploadedFileName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'SSCT updated successfully' });
      });
      this.subscriptions.add(sub);
    }
    
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "SSCT", value: this.RFPForm.get('comment')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }

 
}
